import className from '../../../common/className.js'

import {
  updateLabelConfig,
  packagingWeightSelector,
  isLabelPropertyEnabledSelector,
} from '../../../data/labelInfos/index.js'

import WeightInput from '../../../common/components/Form/WeightInput.js'
import {useSelector} from '../../../store.js'
import EnableLabelProperty, {PickLabelProperty} from './EnableLabelProperty.js'
import {
  AMAZON_SFP,
  DHL,
  FEDEX,
  PITNEY_CBDS,
  PITNEY,
  PITNEY_MERCHANT,
  PITNEY_PRESORT,
  UPS,
  USPS_SHIP,
  FEDEX_360,
} from '../../../common/constants/ShipperNames.js'
import useLabelProperty, {
  defaultValidLabelPropertiesFunc,
  ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
  formatMetaClassName,
} from './useLabelProperty.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import LabelItem from '../../OrderListPage/OrderListRow/OrderData/Fields/LabelItem.js'
import Weight from '../../../common/components/Weight.js'

const LABEL_PROPERTY = 'packaging_weight'
const VALID_SHIPPER_TYPES = [
  AMAZON_SFP,
  DHL,
  FEDEX,
  FEDEX_360,
  PITNEY_CBDS,
  PITNEY,
  PITNEY_MERCHANT,
  PITNEY_PRESORT,
  UPS,
  USPS_SHIP,
]

export default function PackagingWeight() {
  const {
    labelInfoID,
    shipperType,
    onChange,
    isLabelEnableMode,
    isSummary,
    isPickMode,
    isValueSummary,
  } = useLabelConfigContext()
  const propertySpecs = PackagingWeight.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )
  const packagingWeight = useSelector((state) =>
    packagingWeightSelector(state, {labelInfoID}),
  )

  useLabelProperty({
    labelProperty,
    propertySpecs,
  })

  const isLabelPropertyEnabled = useSelector((state) =>
    isLabelPropertyEnabledSelector(state, {
      labelInfoID,
      labelProperty,
    }),
  )

  const disabled = isLabelEnableMode && !isLabelPropertyEnabled

  if (!propertySpecs.validShipperTypes.includes(shipperType)) {
    return null
  }

  const label = 'Packaging Weight'

  if (isSummary) {
    return label
  }

  if (isValueSummary) {
    return (
      <LabelItem label={label}>
        <Weight value={packagingWeight} />
      </LabelItem>
    )
  }

  if (isPickMode) {
    return <PickLabelProperty label={label} labelProperty={labelProperty} />
  }

  return (
    <li
      className={className`list__item--shipping-options btm-offset-7 meta-labelconfigform-container-packagingweight ${formatMetaClassName(
        labelProperty,
      )} ${{
        'property-disabled': disabled,
      }}`}
    >
      <div className="wrap--edit-preset-form-input">
        <label
          className="label--bold label--config__txt"
          htmlFor="labelconfigform-packaging-weight-lb"
        >
          {label}
        </label>
        <WeightInput
          idLb="labelconfigform-packaging-weight-lb"
          weightOz={packagingWeight}
          setWeightOz={(value) => {
            updateLabelConfig(labelInfoID, {[labelProperty]: value})

            onChange()
          }}
          metaClassName={formatMetaClassName(labelProperty)}
          disabled={disabled}
        />
      </div>
      <EnableLabelProperty labelProperty={labelProperty} />
    </li>
  )
}

PackagingWeight.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc() {
      return [LABEL_PROPERTY]
    },
    dependentPropertiesFunc: ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
